import { Component, OnInit, Inject } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { LoadingService } from '../../../../shared/services/loading.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { UpdateInspectionForecastingInfoViewModel } from '../../models/manage-equipment.model';
import { ManageEquipmentService } from '../../manage-equipment.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-update-inspection-forecasting',
  templateUrl: './update-inspection-forecasting.component.html',
  styleUrls: ['./update-inspection-forecasting.component.scss']
})
export class UpdateInspectionForecastingComponent implements OnInit {



  unitList = [
    { Id: 0, Name: 'Hours' },
    { Id: 1, Name: 'Days' }
  ]

  saving: boolean = false;
  selectedEveryUnit: number = 0;
  _equipmentId: number;
  inspectEvery:number;

  controlGroup:FormGroup;
  changeInspectionEveryControl : FormControl;

  // equipmentId: this.equipmentId,
  // inspectEvery : this.equipmentDetails.InspectEvery,
  // inspectEveryUnitType : this.equipmentDetails.InspectEveryUnitTypeId

  constructor(public dialogRef: MatDialogRef<UpdateInspectionForecastingComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _notification: NotificationsService,
    private _loading: LoadingService,
    private _equipmentService : ManageEquipmentService
  ) { }

  ngOnInit() {
    this._equipmentId = this.data.equipmentId;
    this.selectedEveryUnit = this.data.inspectEveryUnitType;
    this.inspectEvery = this.data.inspectEvery;
    this.changeInspectionEveryControl  =  new FormControl('', [
      Validators.required, 
    ]);
    this.controlGroup = new FormGroup({
      changeInspectionEveryControl : this.changeInspectionEveryControl,
    });
  }


  updateInspectionForecastTime() {
    this._loading.startLoading();
    this.saving = true;
    let model = new UpdateInspectionForecastingInfoViewModel();
    model.EquipmentId =  this._equipmentId;
    model.InspectEvery = this.inspectEvery;
    model.InspectEveryUnitType = this.selectedEveryUnit;
    this._equipmentService.updateEquipmentInspectionInfo(model).subscribe(result=>{
      console.log(result);
      this.saving = false;
      this._loading.finishedLoading();
      if(result.m_Item1>0){
        this._notification.success("Inspection Forecasting Changed",result.m_Item2);
        this.dialogRef.close(true);
      }
      else{
       this._notification.error('Error', result.m_Item2);
      }
    });
  }



  onNoClick(): void {
    this.dialogRef.close(false);
  }

}
